import { cn } from '@mntn-dev/ui-utilities'
import { Icon, isIconName } from '../../icon/index.ts'
import type { MenuOptionIcon, MenuOptionIconProps } from './types.ts'

export const getIconElement = (icon?: MenuOptionIcon, disabled?: boolean) => {
  if (!icon) {
    return null
  }

  const props: MenuOptionIconProps = isIconName(icon)
    ? { color: 'info', name: icon }
    : icon

  return (
    <Icon
      size="md"
      fill="solid"
      {...props}
      className={cn(disabled && 'opacity-40')}
    />
  )
}
